// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"283":"e27b39ba72dcb08551e8","310":"8e72ce979361b408c6c0","773":"c01211aa75403da026d1","918":"4c3525fa265306981843"}[chunkId] + ".js";
};